import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Mail, Menu, Phone, X } from "lucide-react";
import Logo from "./Logo";

const PHONE = "+1 (202) 280-0579";
const PHONE_HREF = "tel:+12022800579";
const EMAIL = "SUPPORT@LENDINGLOANSUSA.COM";
const EMAIL_HREF = "mailto:support@lendingloansusa.com";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/#about", label: "About" },
  { to: "/#services", label: "Services" },
  { to: "/#calculator", label: "Calculator" },
  { to: "/#how-it-works", label: "Process" },
  { to: "/#faq", label: "FAQ" },
  { to: "/#contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-white/10 bg-[#050A1F]/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex h-20 max-w-[1480px] items-center justify-between px-6 lg:px-10">
        <Logo />

        <nav className="hidden items-center gap-6 xl:gap-8 lg:flex" aria-label="Primary">
          {links.map((l) => (
            <NavLink
              key={l.label}
              to={l.to}
              end={l.end}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-xs uppercase tracking-[0.28em] transition-colors ${
                  isActive
                    ? "text-[#D4AF37]"
                    : "text-white/70 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-5 lg:flex">
          <a
            href={PHONE_HREF}
            data-testid="header-phone"
            className="hidden items-center gap-2 whitespace-nowrap text-sm text-white/80 transition-colors hover:text-[#D4AF37] [@media(min-width:1440px)]:flex"
          >
            <Phone className="h-3.5 w-3.5 shrink-0 text-[#D4AF37]" strokeWidth={1.6} />
            <span className="tracking-wider">{PHONE}</span>
          </a>
          <Link
            to="/apply"
            data-testid="nav-apply-btn"
            className="whitespace-nowrap border border-[#D4AF37] bg-[#D4AF37] px-5 py-2.5 text-xs uppercase tracking-[0.28em] text-[#050A1F] transition-colors hover:bg-[#F3E5AB]"
          >
            Grab Your Loan
          </Link>
        </div>

        <button
          type="button"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="inline-flex h-10 w-10 items-center justify-center border border-white/15 text-white lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-[#050A1F] lg:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-6">
            {links.map((l) => (
              <NavLink
                key={l.label}
                to={l.to}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.28em] text-white/80 hover:text-[#D4AF37]"
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={PHONE_HREF}
              className="flex items-center gap-2 text-sm text-white/80"
            >
              <Phone className="h-4 w-4 text-[#D4AF37]" />
              {PHONE}
            </a>
            <a
              href={EMAIL_HREF}
              className="flex items-center gap-2 text-sm text-white/80"
            >
              <Mail className="h-4 w-4 text-[#D4AF37]" />
              {EMAIL}
            </a>
            <Link
              to="/apply"
              onClick={() => setOpen(false)}
              className="mt-2 border border-[#D4AF37] bg-[#D4AF37] px-5 py-3 text-center text-xs uppercase tracking-[0.28em] text-[#050A1F]"
            >
              Grab Your Loan Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
